import { render } from "./SubscribtionFotterSec.vue?vue&type=template&id=49e3f120"
import script from "./SubscribtionFotterSec.vue?vue&type=script&lang=js"
export * from "./SubscribtionFotterSec.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__